import { ELumaBotQuestionType } from 'ui-model';

export const questionTypesAllowedToSubmitAnswer: ELumaBotQuestionType[] = [
  ELumaBotQuestionType.Address,
  ELumaBotQuestionType.Date,
  ELumaBotQuestionType.Dropdown,
  ELumaBotQuestionType.Email,
  ELumaBotQuestionType.MedicationSearch,
  ELumaBotQuestionType.NaturalLanguage,
  ELumaBotQuestionType.PharmacySearch,
  ELumaBotQuestionType.PhoneNumber,
  ELumaBotQuestionType.Ssn,
  ELumaBotQuestionType.Text,
  ELumaBotQuestionType.ZipCode,
];
